module.exports = __webpack_public_path__ + "static/Make-happiness-e096384417a1b9eb94f282c01ce11f94.svg";